/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZabbixTemplate extends models.ZabbixElementBase {
    getFixupPrototypeFunction() { return ZabbixTemplate.fixupPrototype; }

    static newInstance(model: Partial<ZabbixTemplate>): ZabbixTemplate {
        let obj = Object.assign(new ZabbixTemplate(), model);
        ZabbixTemplate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZabbixTemplate>): ZabbixTemplate {
        if (!model) return null;
        return ZabbixTemplate.newInstance(<ZabbixTemplate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZabbixTemplate) {
        if (!obj) return;

        models.ZabbixTemplate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZabbixTemplate): boolean {
        if (models.ZabbixElementBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ZabbixTemplate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.number_of_items === undefined) {
            this.number_of_items = 0;
        }
    }

    /**
     * Number of components
     */
    number_of_items: number;

    /**
     * List of linked templates
     */
    linked_templates: Array<string>;

    /**
     * List of linked hosts
     */
    linked_hosts: Array<string>;

}
